export default __webpack_public_path__ + "static/30-sitzer-2-b5c0a2a54d313217bde9e737358cef02.jpg";